import { type Guard } from '../../types';

export const checkIfShouldEncourageMoreChanges: Guard = function (args): boolean {
  const { encouragedChangesList } = args.context;

  return encouragedChangesList.length > 0;
};
